export enum RoleType {
  ADMIN = 'ADMIN',
  RECRUITER = 'RECRUITER',
  OPS = 'OPS',
  DRIVER = 'DRIVER',
}

export enum EmployeeStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
